:host {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 0;

  .quick-link {
    border-bottom-color: transparent;
    color: var(--sdx-color-gray);
    text-decoration: none !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    display: flex;
  }
}

:host(:hover) {
  .quick-link {
    color: var(--sdx-color-int-blue);
  }
}

:host(.focus) {
  .quick-link {
    color: var(--sdx-color-int-blue);
  }
}
